
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indextr0jSyd5ryqedjb_45oz33ABxPWUPKRdJ9DAZDzgBhk1YMeta } from "/builds/cloud/core/frontend-nuxt/pages/index.vue?macro=true";
import { default as indexrZ3tMlLfcF_45Kn742aEoYrrbrUH7mUFDzhKraXHznEC8Meta } from "/builds/cloud/core/frontend-nuxt/pages/mfa/index.vue?macro=true";
import { default as streamingaHd78VxC_2olnBw3ikpcuPC77rivZWyakdB_45jKPG6DUMeta } from "/builds/cloud/core/frontend-nuxt/layers/streaming/pages/streaming.vue?macro=true";
import { default as _91_46_46_46slug_93mypeYoMK9iGCi1UPTj_vXALVO6_v7xP1pXNpB_45RwR5cMeta } from "/builds/cloud/core/frontend-nuxt/pages/@/[...slug].vue?macro=true";
import { default as indexu0YoExefiVjWfQ0LYj7zVx8neAdL4LuioO2NLlT9OlMMeta } from "/builds/cloud/core/frontend-nuxt/pages/login/index.vue?macro=true";
import { default as sentry_45test1bbcc5eoQpzqNBalsjCiWDstrYix_4519d0w_45uVJ2p2PsMeta } from "/builds/cloud/core/frontend-nuxt/pages/sentry-test.vue?macro=true";
import { default as index45ZcRcPfIVwv44AfJLlPstwVHNIclhhUYRVMb64NCFkMeta } from "/builds/cloud/core/frontend-nuxt/pages/terms/index.vue?macro=true";
import { default as indexsD1NUnVzimvl4FoIWu5TG_93S8CLqkxGwrHHmrEl5QMMeta } from "/builds/cloud/core/frontend-nuxt/pages/cookie/index.vue?macro=true";
import { default as indexk14N1oU9_3kCV9fKofYaQyTJZs_45mNJ0_45Eo45iCJ2jBMMeta } from "/builds/cloud/core/frontend-nuxt/pages/privacy/index.vue?macro=true";
import { default as cancelNInsHP6yIczfAXZRckDQ_457AD9m7lfEw5QvfmiOGrRSMMeta } from "/builds/cloud/core/frontend-nuxt/pages/stripe/cancel.vue?macro=true";
import { default as indexzHnLfaOAMPkxqBY8pnYkBplkg_45E_45ZIehn1QVOcCJPOMMeta } from "/builds/cloud/core/frontend-nuxt/pages/welcome/index.vue?macro=true";
import { default as _91link_93l_45PlRNJpWItB_45_45uMY0ObEWBHWVomyhqlk99qAEQr7AQMeta } from "/builds/cloud/core/frontend-nuxt/layers/streaming/pages/sharing/[link].vue?macro=true";
import { default as success16120qQXHr77M0_UwR7uNSmZ_45RxBh5NnVzD0M35KlAIMeta } from "/builds/cloud/core/frontend-nuxt/pages/stripe/success.vue?macro=true";
import { default as indexInXJgbuvYvESqKNEg3RiPqj2VOF5RHtdVRseSxzwTewMeta } from "/builds/cloud/core/frontend-nuxt/pages/verify-email/index.vue?macro=true";
import { default as _91programId_93JH9B0mRHsWnstJSJ5NlmSvLP8qF_453Q_ThdSmwnLqsyMMeta } from "/builds/cloud/core/frontend-nuxt/pages/programs/[programId].vue?macro=true";
import { default as indexeDlroNTs7QkOrAd_45KFeUP4VLC2yP78xWiCG_45s7tbFu4Meta } from "/builds/cloud/core/frontend-nuxt/pages/reset-password/index.vue?macro=true";
import { default as _91categoryId_93lPUELBQsVAKm9bs7Fm6wU6VVXgeLvooRNtNG_oeCpl8Meta } from "/builds/cloud/core/frontend-nuxt/pages/category/[categoryId].vue?macro=true";
import { default as indexYjhw_o5m9bZ3RGrxXqXnkfqEjtW6s6U9WhEFJ5zD9u8Meta } from "/builds/cloud/core/frontend-nuxt/pages/forgot-password/index.vue?macro=true";
import { default as _91developerId_93jOzSSn5FQothI4bElvoD_wKeGgXjjbL4TS8rmoiNmFMMeta } from "/builds/cloud/core/frontend-nuxt/pages/developer/[developerId].vue?macro=true";
import { default as _91publisherId_93WVND_45CEKK88vJxwYCN1Z0LTJY03zjeA7M96r2WEfA54Meta } from "/builds/cloud/core/frontend-nuxt/pages/publisher/[publisherId].vue?macro=true";
import { default as _91provider_93KvHI1xmC1XKBu778_RjyZER3DY1dwDs6R12ahw_45GLCoMeta } from "/builds/cloud/core/frontend-nuxt/pages/auth-callback/[provider].vue?macro=true";
import { default as index_46clientbnRQSEI4AY4FeZPc2a6zxNM1xGRn9myQcMhvRt61wkEMeta } from "/builds/cloud/core/frontend-nuxt/pages/check-email/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/builds/cloud/core/frontend-nuxt/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexkS50FD8sTO7Fqnrt3HT2y2_45bXsaD01zKFc3bV8Rnz1MMeta } from "/builds/cloud/core/frontend-nuxt/pages/email-not-verified/index.vue?macro=true";
import { default as _91licenseType_9395mNrkkn3Sgguj7v4r86e9mnjqocahyb66hu0XKOu1AMeta } from "/builds/cloud/core/frontend-nuxt/pages/license-type/[licenseType].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/index.vue")
  },
  {
    name: "mfa",
    path: "/mfa",
    meta: indexrZ3tMlLfcF_45Kn742aEoYrrbrUH7mUFDzhKraXHznEC8Meta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/mfa/index.vue")
  },
  {
    name: "streaming",
    path: "/streaming",
    meta: streamingaHd78VxC_2olnBw3ikpcuPC77rivZWyakdB_45jKPG6DUMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/layers/streaming/pages/streaming.vue")
  },
  {
    name: "@-slug",
    path: "/@/:slug(.*)*",
    meta: _91_46_46_46slug_93mypeYoMK9iGCi1UPTj_vXALVO6_v7xP1pXNpB_45RwR5cMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/@/[...slug].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexu0YoExefiVjWfQ0LYj7zVx8neAdL4LuioO2NLlT9OlMMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/login/index.vue")
  },
  {
    name: "sentry-test",
    path: "/sentry-test",
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/sentry-test.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index45ZcRcPfIVwv44AfJLlPstwVHNIclhhUYRVMb64NCFkMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/terms/index.vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    meta: indexsD1NUnVzimvl4FoIWu5TG_93S8CLqkxGwrHHmrEl5QMMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/cookie/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: indexk14N1oU9_3kCV9fKofYaQyTJZs_45mNJ0_45Eo45iCJ2jBMMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/privacy/index.vue")
  },
  {
    name: "stripe-cancel",
    path: "/stripe/cancel",
    meta: cancelNInsHP6yIczfAXZRckDQ_457AD9m7lfEw5QvfmiOGrRSMMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/stripe/cancel.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: indexzHnLfaOAMPkxqBY8pnYkBplkg_45E_45ZIehn1QVOcCJPOMMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/welcome/index.vue")
  },
  {
    name: "sharing-link",
    path: "/sharing/:link()",
    props: true,
    meta: _91link_93l_45PlRNJpWItB_45_45uMY0ObEWBHWVomyhqlk99qAEQr7AQMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/layers/streaming/pages/sharing/[link].vue")
  },
  {
    name: "stripe-success",
    path: "/stripe/success",
    meta: success16120qQXHr77M0_UwR7uNSmZ_45RxBh5NnVzD0M35KlAIMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/stripe/success.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: indexInXJgbuvYvESqKNEg3RiPqj2VOF5RHtdVRseSxzwTewMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/verify-email/index.vue")
  },
  {
    name: "programs-programId",
    path: "/programs/:programId()",
    props: true,
    meta: _91programId_93JH9B0mRHsWnstJSJ5NlmSvLP8qF_453Q_ThdSmwnLqsyMMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/programs/[programId].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: indexeDlroNTs7QkOrAd_45KFeUP4VLC2yP78xWiCG_45s7tbFu4Meta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/reset-password/index.vue")
  },
  {
    name: "category-categoryId",
    path: "/category/:categoryId()",
    props: true,
    meta: _91categoryId_93lPUELBQsVAKm9bs7Fm6wU6VVXgeLvooRNtNG_oeCpl8Meta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/category/[categoryId].vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: indexYjhw_o5m9bZ3RGrxXqXnkfqEjtW6s6U9WhEFJ5zD9u8Meta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/forgot-password/index.vue")
  },
  {
    name: "developer-developerId",
    path: "/developer/:developerId()",
    props: true,
    meta: _91developerId_93jOzSSn5FQothI4bElvoD_wKeGgXjjbL4TS8rmoiNmFMMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/developer/[developerId].vue")
  },
  {
    name: "publisher-publisherId",
    path: "/publisher/:publisherId()",
    props: true,
    meta: _91publisherId_93WVND_45CEKK88vJxwYCN1Z0LTJY03zjeA7M96r2WEfA54Meta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/publisher/[publisherId].vue")
  },
  {
    name: "auth-callback-provider",
    path: "/auth-callback/:provider()",
    meta: _91provider_93KvHI1xmC1XKBu778_RjyZER3DY1dwDs6R12ahw_45GLCoMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/auth-callback/[provider].vue")
  },
  {
    name: "check-email",
    path: "/check-email",
    meta: index_46clientbnRQSEI4AY4FeZPc2a6zxNM1xGRn9myQcMhvRt61wkEMeta || {},
    component: () => createClientPage(() => import("/builds/cloud/core/frontend-nuxt/pages/check-email/index.client.vue"))
  },
  {
    name: "email-not-verified",
    path: "/email-not-verified",
    meta: indexkS50FD8sTO7Fqnrt3HT2y2_45bXsaD01zKFc3bV8Rnz1MMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/email-not-verified/index.vue")
  },
  {
    name: "license-type-licenseType",
    path: "/license-type/:licenseType()",
    props: true,
    meta: _91licenseType_9395mNrkkn3Sgguj7v4r86e9mnjqocahyb66hu0XKOu1AMeta || {},
    component: () => import("/builds/cloud/core/frontend-nuxt/pages/license-type/[licenseType].vue")
  }
]